/**
 * Polyfill for CustomEvent.
 * This file is necessary when trying to inherit from CustomEvent because
 * some environments doesn't have CustomEvent (old browser or Node.js).
 */
// Classes
import Event from './Event'; // Types

export default class CustomEvent extends Event {
  constructor(...[type, eventInit]) {
    super(type);
    this.detail = void 0;
    this.detail = (eventInit == null ? void 0 : eventInit.detail) || null;
  }

}
//# sourceMappingURL=CustomEvent.js.map